import {validate, validateAll, serialize, reset} from '../util/form'

const _forms = document.querySelectorAll('form[data-action]');

if(_forms.length && window.js_data.recaptcha_public_key) {
    const script_recaptcha = document.createElement('script');
    script_recaptcha.src = 'https://www.google.com/recaptcha/api.js?onload=recaptcha_onload&render=explicit';
    document.head.appendChild(script_recaptcha);

    window.recaptcha_onload = function () {
        Array.from(document.getElementsByClassName('g-recaptcha')).forEach(function (_r) {
            window.grecaptcha.render(_r, {
                'sitekey': window.js_data.recaptcha_public_key,
                'callback': function (token) {
                    _r.setAttribute('data-token', token);
                    _r.closest('form').dispatchEvent(new Event('submit', {bubbles: true}));
                },
                'expired-callback': function () {
                },
                'error-callback': function () {
                },
            });
        });
    };
}

_forms.forEach(_form => {
    _form.setAttribute('novalidate', '');
    _form.addEventListener('input', ({ target }) => {
        if(['INPUT','TEXTAREA', 'SELECT'].includes(target.tagName)) {
            validate(target);
            validateAll(_form, false, false);
        }
    });

    const backdrop = _form.querySelector('.js-backdrop');
    const closeEl = _form.querySelector('[data-c-toggle="close"]');

    let sending = false;

    _form.addEventListener('submit', function (e) {
        e.preventDefault();

        if (sending || !validateAll(_form)) {
            if(window.grecaptcha) {
                window.grecaptcha.reset();
            }
            return;
        }

        const nonce_field = _form.querySelector('[name="_wprestapi"]');
        let nonce = {};
        if(nonce_field) {
                nonce = {'X-WP-Nonce' : nonce_field.value};
        }

        sending = true;
        _form.classList.add('loading');

        fetch(_form.getAttribute('data-action'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...nonce,
            },
            body: serialize(_form),
        })
            .then(r => {
                if(r.status >= 500) {
                    return r.text();
                }
                return r.json();
            })
            .then((json) => {
                if(typeof json !== 'object') {
                    throw Error(json)
                }
                _form.classList.remove('loading');

                reset(_form);
                _form.dispatchEvent(new CustomEvent('form_submitted', {detail: json}));

                if(json.message && backdrop) {
                    _form.classList.add('message');
                    backdrop.innerText = json.message;

                    setTimeout(() => {
                        _form.classList.remove('message');
                        backdrop.innerText = '';
                        if(closeEl) {
                            closeEl.dispatchEvent(new Event('click'));
                        }
                    }, 5000)
                }

                sending = false;
                if(window.grecaptcha) {
                    window.grecaptcha.reset();
                }
            })
            .catch(err => {
                _form.classList.remove('loading');
                sending = false;
                console.error(err);
            })
    });
});



// WEBPACK FOOTER //
// ./scripts/autoload/form.js